var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailyInpirationMenuSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9677 12.5008C18.7655 11.1494 17.6143 10.1864 16.3075 10.1242C16.6342 8.91265 17.4276 8.43111 18.3921 8.15152C18.4855 8.12045 18.4699 8.02725 18.4699 8.02725L18.3143 7.06419C18.3143 7.06419 18.2988 6.98652 18.1743 7.00205C14.8451 7.37485 12.5893 9.90677 13.0093 12.9824C13.3983 15.1104 15.0629 15.9337 16.6031 15.7162C18.1432 15.4677 19.2011 14.0386 18.9677 12.5008ZM8.34217 10.1242C8.65332 8.91265 9.47785 8.43111 10.4268 8.15152C10.5202 8.12045 10.5046 8.02725 10.5046 8.02725L10.3646 7.06419C10.3646 7.06419 10.3491 6.98652 10.2246 7.00205C6.87979 7.37485 4.65511 9.90677 5.04404 12.9824C5.44853 15.1104 7.12871 15.9337 8.65332 15.7162C10.1935 15.4677 11.2514 14.0386 11.0025 12.5008C10.8002 11.1339 9.66453 10.1708 8.34217 10.1242Z",
    fill: "#4b2b5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyInpirationMenuSvg);
export default __webpack_public_path__ + "static/media/dailyInpirationMenuSvg.a0373dc9fb6f68a601b910d5c677d4a8.svg";
export { ForwardRef as ReactComponent };